// Configuración de WhatsApp para Babilonia Calzados
// Formato del número: código de país + número sin el símbolo +
// Ejemplo: Argentina (54) + 9 + código de área + número
// Para: +54 9 11 1234-5678 -> usar: 5491112345678

export const WHATSAPP_CONFIG = {
  // Cambiar este número por el número real de WhatsApp de la tienda
  phoneNumber: '5493413543521', // 👈 CAMBIAR AQUÍ
  
  // Nombre de la tienda
  storeName: 'Babilonia Calzados',
  
  // Mensaje de bienvenida
  greeting: '🛍️ *Hola! Quiero hacer un pedido de Babilonia Calzados* 🛍️',
};
